import BaseComponent from '../../components/base-component/base-component'
import { bodyElement } from '../../components/common/body-element'
import { parseHTML } from '../../utils/dom'

class ProductRecommendations extends BaseComponent {
  intersectionObserver: IntersectionObserver

  constructor() {
    super()

    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersectionObserve,
      { rootMargin: '0px 0px 200px 0px' },
    )
    this.intersectionObserver.observe(this)
  }

  disconnectedCallback(): void {
    this.intersectionObserver.disconnect()
  }

  handleIntersectionObserve = (
    entries: IntersectionObserverEntry[],
    observer: IntersectionObserver,
  ): void => {
    if (!entries[0].isIntersecting) {
      return
    }

    observer.unobserve(this)

    const url = this.dataset.url

    if (!url) {
      return
    }

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = parseHTML(text)

        this.updateByHTML(html)
      })
      .catch(() => {
        if (!bodyElement.notification) {
          return
        }

        bodyElement.notification.show(
          'Error in product recommendations component',
          'warning',
        )
      })
  }

  updateByHTML(html: Document): void {
    const recommendations = html.querySelector('product-recommendations')

    if (recommendations) {
      const clonedRecommendations = recommendations.cloneNode(true)

      this.replaceChildren(...clonedRecommendations.childNodes)
    }
  }
}

export default ProductRecommendations
